module.exports = __webpack_public_path__ + "static/dubai-9e0b4d13251bc183c4897ffb5c66be6a.jpg";